import { createContext, PropsWithChildren, useState } from "react";
import { ToastContainer } from "react-bootstrap";
import { CloseableToastComponentType } from "../components/common/CloseableToast";

type ToastMap = Map<number, CloseableToastComponentType>;

type ToastState = {
  toasts: ToastMap;
  createToast: (toast: CloseableToastComponentType) => void;
  deleteToast: (id: number) => void;
}

export const ToastContext = createContext<ToastState>({ toasts: new Map(), createToast: () => {}, deleteToast: () => {} });

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const [toasts, setToasts] = useState<ToastMap>(new Map());
  
  const createToast = (toast: CloseableToastComponentType) => {
    toasts.set(Math.random(), toast);
    setToasts(new Map(toasts));
  }
  const deleteToast = (id: number) => {
    toasts.delete(id);
    setToasts(new Map(toasts));
  }
  
  return (
    <ToastContext.Provider value={{ toasts, createToast, deleteToast }}>
      <ToastContainer position="bottom-center" style={{ position: 'fixed', padding: "1em" }}>
        {Array.from(toasts).map(([id, Component]) => (
          <Component key={`toast-${id}`} handleRemove={() => deleteToast(id)} />
        ))}
      </ToastContainer>
      {children}
    </ToastContext.Provider>
  )
}
